import React, { useState } from "react";
import Clouds from "./Clouds";
import BrollVid from "./BrollVid";
import styled from "@emotion/styled";

const Broll = (props) => {
  const Container = styled.div`
    min-width: 1200px;
    padding-top: 5vh;
    position: relative;
    box-sizing: border-box;
    @media (max-width: 1100px) {
      min-width: 0;
    }
  `;

  const Text = styled.div`
    font-size: 4vw;
    margin-bottom: 10vh;
    z-index: 15;
    position: relative;
    font-weight: 550;
  `;
  const Color = styled.span`
    color: black;
  `;

  return (
    <Container>
      <Text>
        Original <Color>Physics</Color>
      </Text>
      <Text>
        Original <Color>Gameplay</Color>
      </Text>
      <BrollVid></BrollVid>
    </Container>
  );
};

export default Broll;
